import { pxToRem } from 'styles/functions'

// same client as hiltonquebec
const Theme = {
  body_background_color: '#104C97',
  header_border_color: 'transparent',

  logo_image_url: 'lacleamy.png',
  logo_height: 100,

  token_hidden: true,
  number_hidden: true,

  button_radius: 4,
  button_color: '#009CDE',

  button_text_size: 16,
  button_text_lineheight: 24,
  button_text_weight: 700,

  text_font: `'Loew', sans-serif`,

  title_font: `'Loew', sans-serif`,
  title_size: 28,
  title_lineheight: 38,
  title_weight: 800,
  title_margin: `${pxToRem(10)} 0 ${pxToRem(10)} ${pxToRem(10)} `,

  separator_color: '#009CDE',

  footer_border_color: 'transparent',
}

export default Theme
